// extracted by mini-css-extract-plugin
export var BlackText = "HumanitixSlice-module--BlackText--ZUFF3";
export var HiddenLg = "HumanitixSlice-module--HiddenLg--UVSlU";
export var HiddenMd = "HumanitixSlice-module--HiddenMd--se8i-";
export var HiddenXl = "HumanitixSlice-module--HiddenXl--2ZzdM";
export var HiddenXs = "HumanitixSlice-module--HiddenXs--y7475";
export var TextAlignRightXs = "HumanitixSlice-module--TextAlignRightXs--4+nLt";
export var WhiteText = "HumanitixSlice-module--WhiteText--1-hgp";
export var black = "#181818";
export var blackHSL = "0 0% 9%";
export var desktopWidth = "960px";
export var humanitix = "HumanitixSlice-module--humanitix--AjfvW";
export var lgBreakpoint = "60rem";
export var mdBreakpoint = "40rem";
export var srOnly = "HumanitixSlice-module--sr-only--59DCa";
export var visuallyHidden = "HumanitixSlice-module--visually-hidden--ANDmG";
export var white = "#fcfcfc";
export var whiteHSL = "0 0% 99%";